module.exports = __webpack_public_path__ + "static/media/screenshot.8bcdf72e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/SchweizerIllustrierteShowcasePhone/screenshot.jpg
// module id = 222
// module chunks = 0